import { GetEntitiesResponse } from '@backstage/catalog-client';
import { useApi } from '@backstage/core-plugin-api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import { useCallback } from 'react';

const entityType = [
  'System',
  'Capability',
  'Guardrail',
  'Api',
  'Group',
  'Docs',
  'Component',
  'User',
  'GroupInfo',
] as const;


export type EntityType = typeof entityType[number];

const useCustomEntities = (entity: EntityType) => {
  const catalogApi = useApi(catalogApiRef);
  const getCustomEntitiesByKind =
    useCallback(async (): Promise<GetEntitiesResponse> => {
      const data = await catalogApi.getEntities({
        filter: { kind: entity },
      });
      return data;
    }, [catalogApi,entity]);

  return { getCustomEntitiesByKind };
};
export default useCustomEntities;
